import { AsyncPipe, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from "@angular/core";
import { TranslocoModule, TranslocoService } from "@ngneat/transloco";
import { BehaviorSubject, Observable } from "rxjs";
import { filter, first, map, switchMap } from "rxjs/operators";
import { TablePlaceholderComponent } from "../table-placeholder/table-placeholder.component";

@Component({
  selector: "app-grid-wrapper",
  templateUrl: "./grid-wrapper.component.html",
  styleUrls: ["./grid-wrapper.component.scss"],
  standalone: true,
  imports: [AsyncPipe, NgIf, TranslocoModule, TablePlaceholderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridWrapperComponent {
  @Input() showPlaceholder = false;
  @Input() placeholderText = this.transloco.translate("grid.noDataAvailable");
  @Input() placeholderTextTemplate?: TemplateRef<unknown>;

  private dataSubject = new BehaviorSubject<unknown[] | undefined>(undefined);

  @Input() set gridData(value: unknown[]) {
    this.dataSubject.next(value);
  }

  protected gridData$: Observable<{ hasData: boolean }> = this.dataSubject.pipe(
    filter((data) => data !== undefined),
    switchMap(() =>
      this.dataSubject.pipe(
        filter((data) => data !== undefined),
        map((data) => ({ hasData: this.hasGridData(data) }))
      )
    ),
    first()
  );

  constructor(private transloco: TranslocoService) {}

  private hasGridData(data: unknown): boolean {
    if (!this.showPlaceholder) {
      return true;
    }
    return Array.isArray(data) && data.length > 0;
  }
}
